import React from 'react'
import PropTypes from 'prop-types'
import { MaterialLoader } from '../'
import styles from './loader-overlay.styl'
import { delayRender } from 'helpers/decorators'

const LoaderOverlay = ({ isLoading = false, children, style }) => (
  <div
    className={[styles.overlay, isLoading ? styles.isLoading : ''].join(' ')}
    style={style}
  >
    {isLoading && (
      <div className={styles.loader}>
        <MaterialLoader />
      </div>
    )}
    {children}
  </div>
)

LoaderOverlay.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  style: PropTypes.object
}

export default delayRender()(LoaderOverlay)
